import { render, staticRenderFns } from "./LayoutSingle.vue?vue&type=template&id=2b4a141c&scoped=true&"
import script from "./LayoutSingle.vue?vue&type=script&lang=js&"
export * from "./LayoutSingle.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSingle.vue?vue&type=style&index=0&id=2b4a141c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4a141c",
  null
  
)

export default component.exports